import { GetCompensationCycleDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

/**
 * Hook to fetch the company's compensation cycle
 * @returns The compensation cycle data and loading state
 */
export const useCompensationCycle = () => {
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(GetCompensationCycleDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const cycles = data?.compensations?.cyclesConnection?.nodes || []

  const mainLegalEntity = company.legalEntities?.find((entity) => entity.main)

  const compensationCycle =
    cycles.length > 0
      ? cycles.find(
          (cycle) =>
            mainLegalEntity &&
            cycle.country === mainLegalEntity.country &&
            cycle.currency === mainLegalEntity.currency
        ) || cycles[0]
      : undefined

  const cycleRecurrence = compensationCycle?.recurrence || 'monthly'

  return {
    compensationCycle,
    loading,
    error,
    cycleRecurrence,
  }
}
